import { createSlice } from '@reduxjs/toolkit';
import React from 'react';
import { Webinar } from './WebinarsType';

export interface WebinarType {
  lessons: Webinar[];
  webinars: Webinar[];
  streams: Webinar[];
}

const initialState: WebinarType = {
  lessons: [
    {
      number: '10',
      theme: 'Регистрация в ОРД',
      urlParam: 'registratsia_v_ord',
      ordAttribute: 'V_ord_registration',
      sberUrl:
        'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/ord_registration.mp4',
      url: 'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/ord_registration.mp4',
      imgUrl: '/assets/img/video/ord_registration.png',
      subThemes: [],
    },
    {
      number: '5',
      theme: 'Как зарегистрировать организацию',
      urlParam: 'kak_zaregestrirovatsa_v_ord',
      ordAttribute: 'V_reg_org',
      sberUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%9E%D1%80%D0%B3%D0%B0%D0%BD%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D0%B8.mp4',
      url: 'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%9E%D1%80%D0%B3%D0%B0%D0%BD%D0%B8%D0%B7%D0%B0%D1%86%D0%B8%D0%B8.mp4',
      imgUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/organizations.jpg',
      subThemes: [
        {
          text: 'Как зарегистрировать организацию',
          timeCode: 3,
        },
        {
          text: 'Тип организации',
          timeCode: 9,
        },
        {
          text: 'Название организации ',
          timeCode: 32,
        },
        {
          text: 'ИНН',
          timeCode: 37,
        },
        {
          text: 'Сведения об ИС',
          timeCode: 49,
        },
        {
          text: 'ОРС/РР',
          timeCode: 60,
        },
        {
          text: 'Площадки',
          timeCode: 85,
        },
        {
          text: 'Название площадки',
          timeCode: 107,
        },
        {
          text: 'Ссылка',
          timeCode: 113,
        },
        {
          text: 'Пользовательский идентификатор',
          timeCode: 120,
        },
        {
          text: 'Владелец площадки',
          timeCode: 135,
        },
        {
          text: 'Сохранение организации',
          timeCode: 158,
        },
        {
          text: 'Журнал услуг',
          timeCode: 167,
        },
        {
          text: 'Детали ошибки',
          timeCode: 188,
        },
        {
          text: 'Список организаций ',
          timeCode: 194,
        },
        {
          text: 'Фильтрация',
          timeCode: 202,
        },
        {
          text: 'Поставщик данных',
          timeCode: 217,
        },
      ],
    },
    {
      number: '2',
      theme: 'Как зарегистрировать договор',
      urlParam: 'kak_zaregestrirovat_dogovor',
      ordAttribute: 'V_reg_con',
      sberUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%D1%8B.mp4',
      url: 'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%D1%8B.mp4',
      imgUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/contracts.jpg',
      subThemes: [
        {
          text: 'Как зарегистрировать договор',
          timeCode: 1,
        },
        {
          text: 'Тип договора',
          timeCode: 10,
        },
        {
          text: 'Договор оказания услуг',
          timeCode: 55,
        },
        {
          text: 'Предмет договора',
          timeCode: 58,
        },
        {
          text: 'Номер договора и дата',
          timeCode: 78,
        },
        {
          text: 'Заказчик и исполнитель',
          timeCode: 90,
        },
        {
          text: 'Сумма договора',
          timeCode: 113,
        },
        {
          text: 'Редактирование договора',
          timeCode: 140,
        },
        {
          text: 'Журнал услуг',
          timeCode: 147,
        },
        {
          text: 'Регистрация доп.соглашения',
          timeCode: 156,
        },
        {
          text: 'Номер доп соглашения',
          timeCode: 170,
        },
        {
          text: 'Основной договор',
          timeCode: 185,
        },
        {
          text: 'Сумма доп соглашения',
          timeCode: 193,
        },
        {
          text: 'Журнал услуг',
          timeCode: 214,
        },
        {
          text: 'Список договоров',
          timeCode: 218,
        },
      ],
    },
    {
      number: '4',
      theme: 'Как зарегистрировать креатив',
      urlParam: 'kak_zaregestrirovat_creativ',
      ordAttribute: 'V_reg_cre',
      sberUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%9A%D1%80%D0%B5%D0%B0%D1%82%D0%B8%D0%B2%D1%8B.mp4',
      url: 'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%9A%D1%80%D0%B5%D0%B0%D1%82%D0%B8%D0%B2%D1%8B.mp4',
      imgUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/creatives.jpg',
      subThemes: [
        {
          text: 'Как зарегистрировать креатив',
          timeCode: 3,
        },
        {
          text: 'Тип оплаты',
          timeCode: 10,
        },
        {
          text: 'Форма креатива',
          timeCode: 22,
        },
        {
          text: 'Самореклама/нет',
          timeCode: 37,
        },
        {
          text: 'Изначальный договор',
          timeCode: 43,
        },
        {
          text: 'Код ОКВЭД',
          timeCode: 70,
        },
        {
          text: 'Описание креатива',
          timeCode: 95,
        },
        {
          text: 'Маркер',
          timeCode: 122,
        },
        {
          text: 'Социальная/Нативаная реклама',
          timeCode: 138,
        },
        {
          text: 'Целевые ссылки',
          timeCode: 144,
        },
        {
          text: 'Медиаданные креатива',
          timeCode: 180,
        },
        {
          text: 'Пользовательский идентификатор',
          timeCode: 214,
        },
        {
          text: 'Текстовые данные',
          timeCode: 230,
        },
        {
          text: 'Сохранение',
          timeCode: 264,
        },
        {
          text: 'Маркер',
          timeCode: 274,
        },
        {
          text: 'Журнал услуг',
          timeCode: 285,
        },
      ],
    },
    {
      number: '6',
      theme: 'Как зарегистрировать саморекламу',
      urlParam: 'kak_zaregestrirovat_samoreklamu',
      ordAttribute: 'V_reg_self',
      sberUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%A1%D0%B0%D0%BC%D0%BE%D1%80%D0%B5%D0%BA%D0%BB%D0%B0%D0%BC%D0%B0.mp4',
      url: 'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%A1%D0%B0%D0%BC%D0%BE%D1%80%D0%B5%D0%BA%D0%BB%D0%B0%D0%BC%D0%B0.mp4',
      imgUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/creativesSelf.jpg',
      subThemes: [
        {
          text: 'Как зарегистрировать креатив',
          timeCode: 3,
        },
        {
          text: 'Тип оплаты',
          timeCode: 14,
        },
        {
          text: 'Форма креатива',
          timeCode: 20,
        },
        {
          text: 'Самореклама/нет',
          timeCode: 30,
        },
        {
          text: 'Организация',
          timeCode: 36,
        },
        {
          text: 'Код ОКВЭД',
          timeCode: 47,
        },
        {
          text: 'Описание креатива',
          timeCode: 57,
        },
        {
          text: 'Маркер',
          timeCode: 70,
        },
        {
          text: 'Социальная/Нативаная реклама',
          timeCode: 86,
        },
        {
          text: 'Целевые ссылки',
          timeCode: 94,
        },
        {
          text: 'Медиаданные креатива',
          timeCode: 94,
        },
        {
          text: 'Ссылка на облачное хранилище',
          timeCode: 113,
        },
        {
          text: 'Пользовательский идентификатор',
          timeCode: 134,
        },
        {
          text: 'Сохранение',
          timeCode: 157,
        },
        {
          text: 'Маркер',
          timeCode: 164,
        },
        {
          text: 'Журнал услуг',
          timeCode: 170,
        },
        {
          text: 'Детали ошибки',
          timeCode: 185,
        },
      ],
    },
    {
      number: '8',
      theme: 'Акты со статистикой',
      urlParam: 'akti_so_statistikoi',
      ordAttribute: 'V_invoice_stat',
      sberUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/invoicestat.mp4',
      url: 'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/invoicestat.mp4',
      imgUrl: 'assets/img/video/invoicestat.png',
      subThemes: [
        {
          text: 'Как зарегистрировать акт',
          timeCode: 7,
        },
        {
          text: 'Номер и дата акта',
          timeCode: 14,
        },
        {
          text: 'Как найти актируемый договор',
          timeCode: 30,
        },
        {
          text: 'Роли заказчика и исполнителя',
          timeCode: 49,
        },
        {
          text: 'Сумма акта',
          timeCode: 60,
        },
        {
          text: 'Разаллокация',
          timeCode: 76,
        },
        {
          text: 'Изначальный договор',
          timeCode: 83,
        },
        {
          text: 'Сумма по креативам',
          timeCode: 96,
        },
        {
          text: 'Зарегистрировать статистику показов',
          timeCode: 110,
        },
        {
          text: 'Выбрать креатив',
          timeCode: 118,
        },
        {
          text: 'Площадка',
          timeCode: 120,
        },
        {
          text: 'Плановые и фактические даты начала и окончания показов',
          timeCode: 124,
        },
        {
          text: 'Плановое и фактическое количество показов',
          timeCode: 141,
        },
        {
          text: 'Сумма за единицу',
          timeCode: 156,
        },
        {
          text: 'Сохранение акта',
          timeCode: 193,
        },
        {
          text: 'Журнал услуг',
          timeCode: 198,
        },
        {
          text: 'Раздел акты',
          timeCode: 215,
        },
      ],
    },
    {
      number: '9',
      theme: 'Акты с упрощенной статистикой',
      urlParam: 'akti_s_uproshennoi_statistikoi',
      ordAttribute: 'V_invoice_stat',
      sberUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/invoicenostat.mp4',
      url: 'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/invoicenostat.mp4',
      imgUrl: 'assets/img/video/invoicenostat.png',
      subThemes: [
        {
          text: 'Как зарегистрировать акт',
          timeCode: 2,
        },
        {
          text: 'Номер и дата акта',
          timeCode: 17,
        },
        {
          text: 'Как найти актируемый договор',
          timeCode: 25,
        },
        {
          text: 'Роли заказчика и исполнителя',
          timeCode: 30,
        },
        {
          text: 'Сумма акта',
          timeCode: 47,
        },
        {
          text: 'Разаллокация',
          timeCode: 80,
        },
        {
          text: 'Изначальный договор',
          timeCode: 86,
        },
        {
          text: 'Сумма по креативам',
          timeCode: 91,
        },
        {
          text: 'Выбрать креатив',
          timeCode: 108,
        },
        {
          text: 'Сохранение акта',
          timeCode: 124,
        },
        {
          text: 'Журнал услуг',
          timeCode: 133,
        },
        {
          text: 'Раздел акты',
          timeCode: 153,
        },
      ],
    },
    {
      number: '1',
      theme: 'Как зарегистрировать акты без статистики',
      urlParam: 'kak_zaregestrirovat_akti_bez_statistiki',
      ordAttribute: 'V_reg_inv_empty',
      sberUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%90%D0%BA%D1%82%D1%8B%20%D0%B1%D0%B5%D0%B7%20%D1%81%D1%82%D0%B0%D1%82%D0%B8%D1%81%D1%82%D0%B8%D0%BA%D0%B8.mp4',
      url: 'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%90%D0%BA%D1%82%D1%8B%20%D0%B1%D0%B5%D0%B7%20%D1%81%D1%82%D0%B0%D1%82%D0%B8%D1%81%D1%82%D0%B8%D0%BA%D0%B8.mp4',
      imgUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/invoicesNoStatistics.jpg',
      subThemes: [
        {
          text: 'Какие акты',
          timeCode: 5,
        },
        {
          text: 'Как зарегистрировать акт',
          timeCode: 20,
        },
        {
          text: 'Как найти актируемый договор',
          timeCode: 38,
        },
        {
          text: 'Роли заказчика и исполнителя',
          timeCode: 63,
        },
        {
          text: 'Сумма акта',
          timeCode: 80,
        },
        {
          text: 'Разаллокация',
          timeCode: 94,
        },
        {
          text: 'Сохранение акта',
          timeCode: 122,
        },
      ],
    },
    {
      number: '7',
      theme: 'Как зарегистрировать статистику',
      urlParam: 'kak_zaregestrirovat_statistiku',
      ordAttribute: 'V_reg_sta',
      sberUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%A1%D1%82%D0%B0%D1%82%D0%B8%D1%81%D1%82%D0%B8%D0%BA%D0%B0.mp4',
      url: 'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%A1%D1%82%D0%B0%D1%82%D0%B8%D1%81%D1%82%D0%B8%D0%BA%D0%B0.mp4',
      imgUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/wievsStatistics.jpg',
      subThemes: [
        {
          text: 'Как зарегистрировать статистику показов',
          timeCode: 3,
        },
        {
          text: 'Выбрать креатив',
          timeCode: 22,
        },
        {
          text: 'Платформа',
          timeCode: 43,
        },
        {
          text: 'Плановые и фактические даты',
          timeCode: 47,
        },
        {
          text: 'Плановые и фактические показы',
          timeCode: 70,
        },
        {
          text: 'Сумма',
          timeCode: 87,
        },
        {
          text: 'Журнал услуг',
          timeCode: 100,
        },
      ],
    },
    {
      number: '3',
      theme: 'Ключи и интеграция по API',
      urlParam: 'kluchi_i_integratsia_po_API',
      ordAttribute: 'V_keys_API',
      sberUrl:
        'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%9A%D0%BB%D1%8E%D1%87%D0%B8.mp4',
      url: 'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/%D0%9A%D0%BB%D1%8E%D1%87%D0%B8.mp4',
      imgUrl: 'https://telegram-bot.obs.ru-moscow-1.hc.sbercloud.ru/keys.jpg',
      subThemes: [
        {
          text: 'Зачем нужен ключ',
          timeCode: 1,
        },
        {
          text: 'Документация',
          timeCode: 20,
        },
        {
          text: 'Генерация токена',
          timeCode: 29,
        },
        {
          text: 'Создать ключ',
          timeCode: 38,
        },
        {
          text: 'Статус активен',
          timeCode: 65,
        },
        {
          text: 'Копирование токена',
          timeCode: 75,
        },
      ],
    },
  ],
  webinars: [
    {
      number: '1',
      theme: 'ОРД - Вебинар №1 - Ключевые вопросы маркировки рекламы',
      urlParam: 'ORD_Webinar_No1_Kluchevie_voprosi_markirovki_reklami',
      ordAttribute: 'W_#1',
      sberUrl: 'https://sbervideo.sberbank.ru/watch/bEkjEsm2vr5KI6umJkO',
      url: 'https://download.sberdisk.ru/download/file/440541450?token=MvkGOkj1RaEyLqT',
      imgUrl: '/assets/img/index/openwebinar.png',
      subThemes: [
        {
          text: 'Кто должен подавать данные?',
          timeCode: 661,
        },
        {
          text: 'Как удалить данные из ОРД?',
          timeCode: 1479,
        },
        {
          text: 'Что делать с ошибочными и дублированными данными?',
          timeCode: 2085,
        },
        {
          text: 'Где и как можно поэкспериментировать с ОРД, не передавая данные в ЕРИР?',
          timeCode: 2246,
        },
        {
          text: 'Как маркировать прямые видео эфиры?',
          timeCode: 2448,
        },
        {
          text: 'Как маркировать посты в соцсетях?',
          timeCode: 2778,
        },
        {
          text: 'Как маркировать текстовые материалы?',
          timeCode: 3008,
        },
        {
          text: 'Что делать, если кликовой ссылки нет или она недоступна?',
          timeCode: 3303,
        },
        {
          text: 'До какого числа необходимо передавать ежемесячную отчетность?',
          timeCode: 3828,
        },
      ],
    },
    {
      number: '2',
      theme: 'ОРД - Вебинар №2 – Раздел Креативы и работа в ЛК',
      urlParam: 'ORD_Webinar_No2_Razdel_Kreativi_i_rabota_v_LK',
      ordAttribute: 'W_#2',
      sberUrl: 'https://sbervideo.sberbank.ru/watch/31Dy4tkm0A9pCpuw2M',
      url: 'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar2-30-03-2023.mp4',
      imgUrl: '/assets/img/index/webinar2.png',
      subThemes: [
        {
          text: 'Чем отличаются типы маркеров в ОРД от SberAds?',
          timeCode: 732,
        },
        {
          text: 'Как заполнять описание креатива?',
          timeCode: 1077,
        },
        {
          text: 'Что такое "Пользовательский идентификатор"?',
          timeCode: 1638,
        },
        {
          text: 'Что делать, если акт выставляется раз в квартал, при том что отчитываться надо раз в месяц?',
          timeCode: 1982,
        },
        {
          text: 'Какие атрибуты изначального договора необходимо передавать между участниками цепочки?',
          timeCode: 2827,
        },
        {
          text: 'Зачем нужна интеграция по API и как её осуществить?',
          timeCode: 3847,
        },
      ],
    },
    {
      number: '3',
      theme: 'ОРД - Вебинар №3 - Регистрация креативов и маркировка',
      urlParam: 'ORD_Webinar_No3_Registratsiya_kreativov_i_markirovka',
      ordAttribute: 'W_#3',
      sberUrl: 'https://sbervideo.sberbank.ru/watch/EJZ9xibW5zPpC6uJAB1',
      url: 'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar3-13-04-2023.mp4',
      imgUrl: '/assets/img/index/webinar3.png',
      subThemes: [
        {
          text: 'Как лучше регистрировать креативы: монолитом или по частям?',
          timeCode: 360,
        },
        {
          text: 'Какие самые старые креативы необходимо регистрировать?',
          timeCode: 622,
        },
        {
          text: 'Что делать, если в акте не только услуги по интернет-рекламе?',
          timeCode: 1013,
        },
        {
          text: 'Как регистрировать ресайзы?',
          timeCode: 1514,
        },
        {
          text: 'Что делать, если стоимость одного целевого действия различается?',
          timeCode: 1754,
        },
        {
          text: 'Что такое формато-логический контроль и как в нем разобраться?',
          timeCode: 2220,
        },
        {
          text: 'Как правильно маркировать кликовую ссылку?',
          timeCode: 2669,
        },
      ],
    },
    {
      number: '4',
      theme: 'ОРД - Вебинар №4 – Статистика и отчётность',
      urlParam: 'ORD_Webinar_No4_Statistika_i_otchetnost',
      ordAttribute: 'W_#4',
      sberUrl: 'https://sbervideo.sberbank.ru/watch/EJ6odfbD6WNZH6u3kd',
      url: 'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar4-22-05-2023.mp4',
      imgUrl: '/assets/img/index/webinar4.png',
      subThemes: [
        {
          text: 'Новости ОРД. Статистика показов и акты будут разделены',
          timeCode: 795,
        },
        {
          text: 'Новости ОРД. Новые отчеты - Отчет о событиях и отчет о количестве объектов.',
          timeCode: 1070,
        },
        {
          text: 'Регистрируется ли более одного маркера для составного креатива?',
          timeCode: 1320,
        },
        {
          text: 'Специфика посреднеческого договора',
          timeCode: 1894,
        },
        {
          text: 'Что делать если ЕРИР или ваш ОРД недоступен?',
          timeCode: 2319,
        },
        {
          text: 'Как работать с объектами в разных статусах наего ОРД?',
          timeCode: 2885,
        },
      ],
    },
    {
      number: '5',
      theme: 'ОРД - Вебинар №5 – Регистрация актов и разаллокация',
      urlParam: 'ORD_Webinar_No5_Regisratsia_aktov_i_razallokatsiya',
      ordAttribute: 'W_#5',
      sberUrl: 'https://sbervideo.sberbank.ru/watch/wzknNh2oyvogFouGX8',
      url: 'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar5-08-06-2023.mp4',
      imgUrl: '/assets/img/index/webinar5.png',
      subThemes: [
        {
          text: 'Новости ОРД. Регистрация и повторная регистрация в SSO на нашем сайте.',
          timeCode: 567,
        },
        {
          text: 'Как регистрировать акты и разаллокации в длинных цепочках.',
          timeCode: 1006,
        },
        {
          text: 'В каких случаях нужно регистрировать e-mail и push-рассылки?',
          timeCode: 1999,
        },
        {
          text: 'Что делать, если обновилась площадка?',
          timeCode: 2136,
        },
        {
          text: 'Что делать, если изменился зарегистрированный креатив?',
          timeCode: 2319,
        },
      ],
    },
    {
      number: '6',
      theme: 'ОРД - Вебинар №6: Проверка качества данных в ЕРИР',
      urlParam: 'ORD_Webinar_No6_Proverka_kachestva_dannih_v_ERIR',
      ordAttribute: 'W_#6',
      sberUrl: 'https://sbervideo.sberbank.ru/watch/xO5VKI1kWdN8uXuQ0G?t=387',
      url: 'https://download.sberdisk.ru/download/file/460360275?token=GaQyZXStg06bsQk',
      imgUrl: '/assets/img/index/webinar6.png',
      subThemes: [
        {
          text: 'Регистрация кобрендинга',
          timeCode: 1197,
        },
        {
          text: 'Как правильно регистрировать контрагента, если РР в период сотрудничества меняет свой статус',
          timeCode: 1355,
        },
        {
          text: 'Что делать если по размещенному креативу не было актирования',
          timeCode: 1374,
        },
        {
          text: 'Нужно ли маркировать саморекламу',
          timeCode: 1721,
        },
      ],
    },
    {
      number: '7',
      theme: 'ОРД - Вебинар №7: Актуальная статистика',
      urlParam: 'ORD_Webinar_No7_Aktualnaya_statistika',
      ordAttribute: 'W_#6',
      sberUrl:
        'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar-2024-11-27.webm',
      url: 'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar-2024-11-27.webm',
      imgUrl: '/assets/img/index/webinar7.png',
      subThemes: [],
    },
    {
      number: '9',
      theme: 'ОРД - Вебинар: API V4 2025.02.12',
      urlParam: 'ORD_Webinar_api_v4_20250212',
      ordAttribute: 'W_api_v4_20250212',
      sberUrl:
        'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar_api_v4_20250212.mp4',
      url: 'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar_api_v4_20250212.mp4',
      imgUrl:
        'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar_api_v4_preview_20250212.jpeg',
      subThemes: [],
    },
    {
      number: '10',
      theme: 'ОРД - Вебинар: Качество данных 2025.02.20',
      urlParam: 'ORD_Webinar_kachestvo_dannih_20250220',
      ordAttribute: 'W_api_v4_20250220',
      sberUrl:
        'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar_kachestvo_dannih_20250220.mp4',
      url: 'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar_kachestvo_dannih_20250220.mp4',
      imgUrl:
        'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar_kachestvo_dannih_preview_20250220.jpeg',
      subThemes: [],
    },
    {
      number: '8',
      theme: 'ОРД - Вебинар: API V4 2025.03.06',
      urlParam: 'ORD_Webinar_api_v4_260325',
      ordAttribute: 'W_api_v4_260325',
      sberUrl:
        'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar_api_v4_260325.mp4',
      url: 'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar_api_v4_260325.mp4',
      imgUrl:
        'https://ord-website.obs.ru-moscow-1.hc.sbercloud.ru/webinar_api_v4_preview_260325.jpeg',
      subThemes: [],
    },
  ],
  streams: [
    {
      number: '1',
      theme:
        'Прямой эфир 04.07.2023 | Презентация ОРД от SberAds для канала "Рекламное право"',
      urlParam:
        'live_stream_04_07_2023_Presentatsiya_ORD_ot_SberAds_dlya_kanala_Reklamnoe_pravo',
      ordAttribute: 'S_#1',
      sberUrl: 'https://www.youtube.com/watch?v=l1Jbqam6ey4&t=4s',
      url: 'https://www.youtube.com/watch?v=l1Jbqam6ey4&t=4s',
      youtubeVideo: (
        <iframe
          width="inherit"
          height="inherit"
          src="https://www.youtube-nocookie.com/embed/l1Jbqam6ey4?si=e15I8ORJfPnv7T1m"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      ),
      imgUrl: 'https://i.ytimg.com/vi/l1Jbqam6ey4/maxresdefault.jpg',
      description: (
        <div>
          Запись Прямого эфира, который состоялся 4 июля 2023г. на YouTube
          канале «Рекламное право»
          <br />
          <strong>Спикеры:</strong>
          <ul className="video-description-list">
            <li>Савва Козловский (Руководитель продукта ОРД от SberAds)</li>
            <li>
              Максим Ларичев (Управляющий директор рекламных продуктов и
              технологий SberAds)
            </li>
          </ul>
          <strong>Модератор:</strong>
          <ul className="video-description-list">
            <li>
              Ирина Шурмина, сооснователь сообщества Рекламное право и WE TALK
              PRO
            </li>
          </ul>
          <strong>Темы эфира:</strong>
          <ul className="video-description-list">
            <li>
              функционал ОРД -регистрация в личном кабинете, как регистрировать
              креатив и подавать отчетность и пр.
            </li>
            <li>тарифы ОРД</li>
            <li>разбор вопросов</li>
          </ul>
        </div>
      ),
      subThemes: [],
    },
  ],
};

export const webinarSlice = createSlice({
  name: 'webinar',
  initialState,
  reducers: {},
});
